module.exports = __webpack_public_path__ + "img/banner2@2x.3d847895.png";